<template>
  <div class="sms-jump-ad">
    <div class="pact">
      <p class="pact-title">服务商合作协议</p>
      <p>甲方： 上海易点时空网络有限公司 （以下称甲方）</p>
      <p>乙方： {{dev.owner_name}}（以下称乙方）</p>
      <p class="pact-content">根据中国法律的规定，甲乙双方遵循自愿、平等、诚信的原则，就乙方服务经销甲方产品的具体事宜达成如下条款，共同遵照执行：</p>
      <p class="sub-title">一、合作内容</p>
      <p class="pact-content">1. 在甲方指定区域内，甲方授权乙方服务经销甲方拥有版权的或在甲方权利范围内开发或经营的路考仪产品（以下简称“服务产品”）。乙方接受甲方委托对服务产品进行宣传、安装、维护及市场策划；甲方专注于服务产品设计、开发。</p>
      <p class="pact-content">2. 合作期间，乙方主要负责：1）在其指定区域内联络有合法经营资质的驾校或其教练，利用自身资源分享服务产品；2）服务产品的拆装指导、调试及维护；3）提供考试相关规则和路线等。</p>
      <p class="sub-title">二、地域限制</p>
      <p class="pact-content">本协议只在 <span></span> 地区有效（以下简称“本地”）。</p>
      <p class="pact-content">经甲方书面同意，乙方可与其他地区服务商协商进行地域限制以外的市场活动。</p>
      <p class="sub-title">三、费用与分成</p>
      <p class="pact-content">1. 服务产品被激活时绑定乙方为服务商的，学员使用该服务产品、通过在甲方平台在线下单的方式直接向甲方支付学时费用，甲方收取学时费用后，依照本协议的约定对乙方支付服务费。</p>
      <p class="pact-content">2. 自服务产品激活成功日起乙方的服务费收取比例为甲方收益的30%，该比例在双方合作期间可随市场变化等因素适当调整，但需经双方沟通确认后方可调整。</p>
      <p class="pact-content">3. 自服务产品激活成功日起第4个月至6个月以内乙方的学时费用分成：</p>
      <p class="pact-content">1) 该期间内产生的学时费用将优先用于返还服务产品押金至产生支付订单时设备所登录的教练的“超级教练”APP平台账户内，押金返完前乙方不参与分成；</p>
      <p class="pact-content">2) 返还服务产品押金后仍有剩余的学时费用，剩余费用按照本协议第三条第2项的比例对乙方进行分成。</p>
      <p class="pact-content">4. 自服务产品激活成功日起第7个月开始乙方的学时费用分成：该期间内产生的学时费用应按照本协议第三条第2项的比例对乙方进行分成。</p>
      <p class="sub-title">四、结算与支付</p>
      <p class="pact-content">乙方每月5号之前需将上一自然月的收入发票快递到上海市闵行区合川路2570号科技绿洲三期2号楼8层（运费由乙方承担）或电子发票发送到lukaoyi@chelun.com   邮箱，具体开票信息详见“超级教练路考仪服务商”平台“我的收入>结算说明”。甲方收到发票后，每个月10号之前将上个自然月的余额自动打款至乙方申请服务商时提供的公司银行账号：                 。因发票延误导致的延期打款问题由乙方承担。</p>
      <p class="sub-title">五、双方的权利义务</p>
      <p class="pact-content">1. 甲方的义务与权利：</p>
      <p class="pact-content">1) 甲方拥有所提供的服务产品的版权和所有权。甲方保证其提供的所有内容的版权合法性，保证内容不违反中国的法律法规强制性规定，并保证由此产生的一切纠纷与损失均由甲方承担。</p>
      <p class="pact-content">2) 甲方作为服务产品的版权人和所有权人，在乙方与其它服务商发生服务权纠纷时，甲方应提供给乙方涉及解决该服务权纠纷所需之帮助。</p>
      <p class="pact-content">3) 甲方有权监督乙方对服务产品的宣传、安装、维护等，并要求乙方予以改进，乙方须配合解决问题。</p>
      <p class="pact-content">4) 甲方应根据乙方的需要提供推动服务产品的租赁资料以及信息，协助乙方获得必要的产品说明，免费提供给乙方宣传品。</p>
      <p class="pact-content">5) 甲方有权根据市场行情设定各地区学员练车单价范围，教练有权在此范围内调整每台设备的具体付费标准。</p>
      <p class="pact-content">6) 乙方在服务期间，如有任何违法、违规操作行为或对甲方名誉、利益产生直接或间接影响的，一经发现，甲方有权取消乙方的服务资格和保留发展其他服务商的权利，同时甲方有权单方面直接终止本协议。</p>
      <p class="pact-content">2. 乙方同意并确认其承担以下主要义务与权利：</p>
      <p class="pact-content">1) 乙方有遵守和维护服务产品使用过程中各地区不同付费标准的义务。</p>
      <p class="pact-content">2) 乙方不得擅自直接或间接使用甲方网站的产品或图案。</p>
      <p class="pact-content">3) 乙方不得有损甲方的形象及声誉。因此而造成的甲方的形象或声誉损害的，甲方有权终止合同，并追究乙方法律责任。</p>
      <p class="pact-content">4) 如果发现他人侵犯服务产品的知识产权等相关权利，乙方应如实向甲方披露，并可根据甲方的书面授权，代表甲方追究侵权方的责任，或按甲方的要求，防范类似行为的发生。</p>
      <p class="pact-content">5) 乙方不得擅自复制或修改甲方产品或对甲方产品实施反向工程。因此而造成甲方损失的，甲方有权终止协议，并追究乙方的法律责任。</p>
      <p class="pact-content">6) 乙方不得将合作期间获知的学员信息等资料提供给除甲方以外的第三方，否则甲方有权终止协议，并要求乙方承担相应的法律责任。</p>
      <p class="pact-content">3. 甲乙双方共同责任与义务：</p>
      <p class="pact-content">1) 甲乙双方共同有为对方保守技术、信息等秘密的义务。</p>
      <p class="pact-content">2) 甲乙双方均有义务对所得的与双方本次合作有关的商业秘密保密，除法律有强制性规定的除外，不能擅自披露、使用或允许他人使用。</p>
      <p class="sub-title">六、免责条款</p>
      <p class="pact-content">1. 由于不可抗力、无法解决的技术原因及其它意外情形所造成的损失，甲乙双方不承担责任：</p>
      <p class="pact-content">“不可抗力”是指受影响一方不能控制的；无法预料或即使预料也不能避免的；于本协议签订日期后出现的；妨碍任一方完全或部分履行本协议的任何事件。该等事件包括但不限于水灾、火灾、旱灾、台风、地震或其它自然灾害、交通意外、罢工、骚动、暴乱及战争（不论曾否宣战）。</p>
      <p class="pact-content">2. 对履行义务的影响：</p>
      <p class="pact-content">如果本协议任何一方受该不可抗力事件影响而未能履行其义务的，该义务的履行在不可抗力事件引起的延误期内中止。</p>
      <p class="pact-content">3. 不可抗力事件的通告及减轻其影响：</p>
      <p class="pact-content">宣称发生不可抗力的一方应尽可能在最短的时间内将不可抗力事件通知另一方，并提供发生不可抗力事件及其持续时间的适当证据。</p>
      <p class="sub-title">七、其他</p>
      <p class="pact-content">1. 本协议自签订之日起自动生效，有效期1年，到期后如需续签，乙方需于本协议到期前30天内向甲方提出书面申请。</p>
      <p class="pact-content">2. 合作期间因快递发票等事项所产生的运费均由寄件方承担。</p>
      <p class="pact-content">3. 本协议未尽事宜，双方应友好协商解决。协商不成，应提交甲方所在地有管辖权的法院诉讼解决。</p>
      <p class="pact-hint">（以下无正文）</p>
      <div class="footer">
        <span>甲   方：上海易点时空网络有限公司</span>
        <span>乙   方：{{dev.owner_name}}</span>
      </div>
      <div class="footer">
        <span>联系人：XXX</span>
        <span>联系人：{{dev.owner_name}}</span>
      </div>
      <div class="footer">
        <span>联系电话：13333333333</span>
        <span>联系电话：{{dev.owner_mobile}}</span>
      </div>
      <div class="footer">
        <span>日期：{{year}}年{{month + 1}}月{{day}}日</span>
        <span>日期：{{year}}年{{month + 1}}月{{day}}日</span>
      </div>
    </div>
  </div>
</template>

<script>
const date = new Date()
export default {
  data () {
    return {
      dev: {
        owner_name: '',
        dev_sn: '',
        owner_mobile: ''
      },
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate()
    }
  },
  created: function () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.pact {
  background: #fff;
  font-size: .24rem;
  line-height: 1.6;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 .3rem;
  z-index: 999;
  padding-bottom: 20px;
  .pact-title {
    text-align: center;
    font-size: .34rem;
    font-weight: 600;
    line-height: 1rem;
  }
  .sub-title {
    margin-top: 10px;
    font-size: .28rem;
    font-weight: 600;
  }
  .pact-content {
    text-indent: 1em;
    span {
      display: inline-block;
      border-bottom: 1px solid #000;
      min-width: 50px;
      text-align: center;
      text-indent: 0;
    }
  }
  .pact-hint {
    text-align: center;
    margin: 20px auto;
  }
  .footer {
    display: -webkit-flex;
    display: flex;
    span:first-child {
      flex: 3;
    }
    span:last-child {
      flex: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pactList/cooperationPact.vue